import styled from 'styled-components';

import {Tile} from './Tile';

const defaultRows = [[320], [64]];

export const LoaderTile = ({rows = defaultRows, withTitle = true}) => {
  return (
    <Tile>
      {withTitle && <div className="animate-pulse rounded-md bg-beige-200 w-2/3 h-6" />}

      {rows.map((row, r) => (
        <div
          key={`rows-${r}`}
          className="flex gap-4 w-full">
          {row.map((height, c) => (
            <StyledPulseBlock
              $delay={(1 + r + c) * 300}
              $height={height}
              key={`row-${c}`}
              className={`flex-grow animate-pulse rounded-md bg-beige-200`}
              style={{}}
            />
          ))}
        </div>
      ))}
    </Tile>
  );
};

const StyledPulseBlock = styled.div<{$height: number; $delay: number}>`
  // Note: using styled component here because struggling with tailwind dynamic class names
  height: ${({$height}) => `${$height}px !important`};
  animation-delay: ${({$delay}) => `${$delay}ms !important`};
  transition-delay: ${({$delay}) => `${$delay}ms !important`};
`;
